


export const Months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
export const Days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];